import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge condicional de classes Tailwind, espelhado do crm_react.
 * Resolve conflitos (ex.: `px-2 px-4` → `px-4`) via tailwind-merge.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
